import { useLazyQuery, useQuery } from "@apollo/client";
import { FavoritesQuery } from "../../../__generated__/FavoritesQuery";
import { FAVORITES } from "../favorites.queries";

export const useFavorites = () => {
  return useQuery<FavoritesQuery>(FAVORITES, {});
};

export const useLazyFavorites = () => {
  return useLazyQuery<FavoritesQuery>(FAVORITES);
};
